import { gql } from '@apollo/client';
import { t } from 'i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from '@tanstack/react-query';
import { executeOperationSafely } from '@stigg-common';
import { apolloClient } from '../../../ApolloClient';
import { RootState } from 'src/redux/store';
import { VerifiedAccountDomainsQuery, VerifiedAccountDomainsQueryVariables } from '@stigg-types/apiTypes';

const VERIFIED_ACCOUNT_DOMAINS = gql`
  query VerifiedAccountDomains {
    verifiedAccountDomains
  }
`;

export const useAccountVerifiedDomains = () => {
  const dispatch = useDispatch();
  const accountId = useSelector((state: RootState) => state.accountReducer.account?.id);

  return useQuery({
    queryKey: ['verifiedAccountDomains', accountId],
    queryFn: () =>
      executeOperationSafely(
        () =>
          apolloClient.query<VerifiedAccountDomainsQuery, VerifiedAccountDomainsQueryVariables>({
            fetchPolicy: 'network-only',
            query: VERIFIED_ACCOUNT_DOMAINS,
          }),
        { failureMessageHandler: () => t('accounts.loginOptions.errors.fetchAccountVerifiedDomainsFailed') },
        dispatch,
      ),
    enabled: true,
    select: (response) => response.data.verifiedAccountDomains,
    retry: 0,
  });
};
